import { CSSObject } from '@emotion/react';
import { theme } from 'styles';

const { color, radius } = theme;

const autoWrap: CSSObject = {
  position: 'relative',
};

const selectedItem = (isSelected: boolean): CSSObject => ({
  background: isSelected ? color.grey75 : color.white,
  borderRadius: radius.sm,
  cursor: 'pointer',
});

const suggestWrap: CSSObject = {
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  top: 44,
  left: 0,
  right: 0,
  zIndex: 2,
  padding: '6px',
  border: `1px solid ${color.grey100}`,
  background: color.white,
  borderRadius: radius.md,
  boxShadow: theme.shadow.popover,
  maxHeight: '200px',
  overflow: 'auto',
  '> li': {
    padding: '10px',
    width: '100%',
    boxSizing: 'border-box',
    fontSize: 14,
  },
};

export { autoWrap, suggestWrap, selectedItem };
